import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useMutation, useQuery } from 'react-query';
import api from '../../../../../components/api';

function useIdRoute() {
  /* id from parameter on current path */
  const { id } = useParams();

  /* initial fetch to get route list data from real time */
  const {
    data, error, isLoading, refetch,
  } = useQuery(
    ['getById', 'routes', id],
    () => api.routes.getById(id!),
    {
      enabled: !!id,
    },
  );

  const resData = React.useMemo(() => (
    data?.data?.data
  ), [data]);

  /* result handler after hit delete route by id API */
  const [result, setResult] = React.useState<any | undefined>(undefined);
  /* mutation for delete client from route */
  const { mutate, isLoading: deleteLoading } = useMutation(api.routes.deleteClient, {
    onMutate: (x) => console.log('onMutate', x),
    onSuccess: (res) => {
      console.log('delete result', res);
      setResult(res);
    },
    onError: (err) => {
      console.log('delete error', err);
      setResult(err);
    },
  });

  /* function for triggering delete API fetch process */
  const handleDelete = (routeId: number, clientId: number) => {
    const removedClients = {
      routeId,
      clientId,
    };
    mutate(removedClients);
  };

  /* Function that are created to handle what will we do after
  click the close button on Modal when success deleting client,
  this function will help you to refresh table data and reset
  result from our last delete API */
  const onAfterResult = async () => {
    await refetch();
    setResult(undefined);
  };

  /* Navigation handler */
  const navigation = useNavigate();

  const onNavigateBack = () => {
    navigation('/routes'); // back to last page
  };

  const onNavigateEdit = () => {
    navigation(`/routes/route/add/${id}`);
  };

  const onNavigateRowEdit = (clientId: number) => {
    navigation(`/routes/route/client/${id}/${clientId}`);
  };

  /* result handler after hit delete route by id API */
  const [resultDeleteRoute, setResultDeleteRoute] = React.useState<any | undefined>(undefined);
  /* mutation for delete client from route */
  const { mutate: mutateDeleteRoute, isLoading: deleteRouteLoading } = useMutation(api.routes.deleteById, {
    onMutate: (x) => console.log('onMutate', x),
    onSuccess: (res) => {
      console.log('delete result', res);
      setResultDeleteRoute(res);
    },
    onError: (err) => {
      console.log('delete error', err);
      setResultDeleteRoute(err);
    },
  });

  const onDeleteRoute = () => {
    if (id) {
      mutateDeleteRoute({
        routeId: parseInt(id, 10),
      });
    }
  };

  const onAfterDeleteRoute = () => {
    setResultDeleteRoute(undefined);
    navigation('/routes');
  };

  return {
    onNavigateBack,
    onNavigateEdit,
    error,
    data,
    refetch,
    isLoading,
    handleDelete,
    deleteLoading,
    result,
    onAfterResult,
    resData,
    onNavigateRowEdit,
    resultDeleteRoute,
    onDeleteRoute,
    onAfterDeleteRoute,
    deleteRouteLoading,
  };
}

export default useIdRoute;
